<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="title">
          组织架构
          <div class="btn" @click="handleAddModal('add')">
            +添加公司
          </div>
        </div>
        <div class="tree">
          <el-tree
            :data="data"
            :props="defaultProps"
            @node-click="handleNodeClick"
            @node-contextmenu="handleContextmenu"
          >
            <!-- <div slot-scope="{ node, data }">
              <el-popover placement="right" width="400" trigger="click">
                
                <div slot="reference">{{ data.name }}</div>
              </el-popover>
            </div> -->
          </el-tree>
          <el-popover
            ref="popover"
            placement="right"
            width="100"
            trigger="manual"
            v-model="visible"
            popper-class="tag-popover"
          >
            <div class="btn-box">
              <div class="btn" @click="handleAddModal" v-if="info.type === 1">
                添加部门
              </div>
              <div class="btn" @click="handleAddModal" v-if="info.type === 2">
                添加职务
              </div>
              <div class="btn" @click="handleUpdateModal">编辑</div>
              <div class="btn" @click="handleDelete">删除</div>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="show" class="dialog" width="480px" top="25vh">
      <div slot="title" class="dialog-title">
        {{ dialogTitle }}
      </div>
      <el-form
        ref="form"
        :model="form"
        class="category-form"
        label-position="top"
        label-width="auto"
        style="padding: 20px 0"
      >
        <div style="margin-bottom: 16px;">{{ dialogTip }}</div>
        <el-form-item
          :label="inputName + '名称：'"
          prop="link"
          class="form-item"
        >
          <el-input
            size="small"
            placeholder="请输入"
            class="input"
            v-model="form.name"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="show = false"
          >取 消</el-button
        >
        <el-button
          class="confirm-btn btn"
          v-if="type === 'add'"
          @click="handleAdd"
          >确 定</el-button
        >
        <el-button
          class="confirm-btn btn"
          v-if="type === 'edit'"
          @click="handleUpdate"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '组织架构',
        secondTitle: '组织架构设置'
      },
      data: [],
      defaultProps: {
        children: 'list',
        label: 'name'
      },
      visible: false,
      show: false,
      form: {
        name: ''
      },
      type: '',
      id: null,
      info: {},
      dialogTitle: '',
      dialogTip: '',
      inputName: ''
    };
  },
  mounted() {
    this.getOrgStructList();
    document.onclick = () => {
        this.visible = false;
        // this.$refs.popover.doDestroy(true);
    }
  },
  computed: {},
  methods: {
    getOrgStructList(){
        this.loading++;
        this.httpGet(this.$root.getOrgStructList, {

        }).then(
            (res) => {
            this.loading--;
            this.data = res.list;
            },
            (res) => {
            this.loading--;
            this.$message.error(res);
            }
        );
    },
    handleNodeClick(data){
        console.log(data);
    },
    handleContextmenu(e, data){
      console.log(data, 123);
        this.id = data.id;
        this.info = data;
        this.visible = false;
        this.$refs.popover.doDestroy(true);
        this.$nextTick(() => {
            this.$refs.popover.referenceElm = e.target;
            this.visible = true;
        });
    },
    handleAddModal(type){
      this.type = 'add';
      this.visible = false;
      this.show = true;
      this.form.name = '';
      if(type === 'add'){
        this.dialogTitle = '添加公司';
        this.inputName = '公司';
        this.dialogTip = '';
        return;
      };
      if(this.info.type === 1){
        this.dialogTitle = '添加部门';
        this.dialogTip = `所属公司: ${this.info.name}`;
        this.inputName = '部门';
      } else if(this.info.type === 2){
        this.dialogTitle = '添加职务';
        this.dialogTip = `所属公司-部门: ${this.info.company.name}-${this.info.name}`;
        this.inputName = '职务';
      };
    },
    handleAdd(){
        let form = {
          name: this.form.name
        };
        if(this.info.type === 1){
          form.type = 2;
          form.companyId = this.info.id;
        } else if(this.info.type === 2){
          form.type = 3;
          form.companyId = this.info.company.id;
          form.departmentId = this.info.id;
        } else {
          form.type = 1;
        };
        this.loading++;
        this.httpPost(this.$root.addOrgStruct, form).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.show = false;
            this.loading--;
            this.getOrgStructList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
    },
    handleUpdateModal(){
        this.type = 'edit';
        this.form.name = this.info.name;
        this.visible = false;
        this.show = true;
        if(this.info.type === 1){
          this.dialogTitle = '编辑公司';
          this.dialogTip = ``;
          this.inputName = '公司';
        } else if(this.info.type === 2){
          this.dialogTitle = '添加部门';
          this.dialogTip = `所属公司: ${this.info.company.name}`;
          this.inputName = '部门';
        } else if(this.info.type === 3){
          this.dialogTitle = '添加职务';
          this.dialogTip = `所属公司-部门: ${this.info.company.name}-${this.info.department.name}`;
          this.inputName = '职务';
        };
    },
    handleUpdate(){
      let form = {
        name: this.form.name,
        id: this.info.id,
        type: this.info.type
      };
      if(this.info.type === 2){
        form.companyId = this.info.company.id;
      } else if(this.info.type === 3){
        form.companyId = this.info.company.id;
        form.departmentId = this.info.department.id;
      };
      this.loading++;
      this.httpPut(this.$root.updateOrgStruct, form).then(
        (res) => {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.show = false;
          this.loading--;
          this.getOrgStructList();
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    handleDelete(){
        this.visible = false;
        this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteOrgStruct, {
          id: this.id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getOrgStructList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
.tag-popover{
    min-width: 100px !important;
    padding: 0 !important
    .btn-box{
        .btn{
            height: 30px;
            cursor: pointer;
            flex-x();
            padding: 0 14px;
            box-sizing: border-box;
            &:hover{
                background: #F6F6F6;
            }
        }
    }
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';
>>>.el-form-item__label{
  padding: 0;
  height: 20px;
  line-height: 20px;
}
.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    // content 表格
    .content {
        padding-top: 0;
        .title{
            height: 64px;
            padding: 0 24px;
            word(20px, #333);
            font-weight: bold;
            border-bottom: 1px solid #FAFAFA;
            flex-x();
            .btn{
                width: 110px;
                height: 28px;
                background: btn-color;
                word(14px, #fff);
                font-weight: normal;
                border-radius: 2px;
                flex-x(center);
                margin-left: 36px;
                cursor: pointer;
            }
        }
        .tree{
            margin: 24px 32px 0;
        }
    }
  }
}
</style>
